module.exports = __webpack_public_path__ + "media/assets/images/flags/in-e60455209db9ac0a6b81b6b2a8fc5677.svg";